"use client";
import { getSimpleTranslation } from "@/libs/translation/Translate";
import styles from "./privacy-policy.module.scss";
import {Fragment} from "react";
import { useSearchParams } from "next/navigation";
import Link from "next/link";

interface IPrivacySection {
    title?: string;
    isHtml?: boolean;
    content: string;
}

export default function PrivacyPolicy() {
    const searchParams = useSearchParams();
    const lang = searchParams.get('lang') || "hy";
    const sections: IPrivacySection[] = [
        {
            title: "Ընդհանուր",
            content: `
                Սույն գաղտնիության քաղաքականությունը հանդիսանում է Հարթակից Օգտվելու Պայմանների բաղկացուցիչ մասը՝ 
                Ձեր և«ՊՐԱԳՄԱՏԻԿՍ» սահմանափակ պատասխանատվությամբ ընկերության (իրավաբանական հասցեն՝ ՀՀ, ք. Երևան,
                Դեմիրճյան փ., շ. 31, բն. 14) միջև իրավաբանորեն պարտադիր պայմանագիր:
            `
        },
        {
            content: `
                Սույն քաղաքականության մեջ հատուկ չսահմանված, մեծատառով գրված եզրույթներն ունեն Հարթակից Օգտվելու
                Պայմաններով դրանց տրված նշանակությունը։
            `
        },
        {
            content: `
                Գաղտնիության սույն քաղաքականությունը («Քաղաքականություն») ուղղված է Ձեզ տեղեկացնելուն Մեր
                քաղաքականության և ընթացակարգերի մասին՝ կապված Ձեզանից ստացվող տվյալների հավաքագրման,
                օգտագործման և բացահայտման հետ:
            `
        },
        {
            content: `
                Օգտվելով Հարթակից՝ Դուք բացահայտ կերպով և անհետկանչելիորեն համաձայնում եք Մեր կողմից Ձեզնից
                ստացվող տվյալների մշակմանը, ներառյալ՝ Հարթակից օգտվելու հետ կապված դրանց հավաքագրմանը,
                օգտագործմանը և բացահայտմանը՝ սույն Քաղաքականության համաձայն: Դուք տալիս եք նշված
                համաձայնությունը թե՛ Ձեր անձնական տվյալների մասով, թե՛ վերաբերելի դեպքերում Երեխայի՝ որպես
                Երեխայի օրինական ներկայացուցիչ։
            `
        },
        {
            content: `
                Դուք պարտավոր չեք համաձայնել սույն Քաղաքականությանը և դրա համաձայն անձնական տվյալների
                տրամադրմանը և մշակմանը: Այնուամենայնիվ,միայն համաձայնելով սույն Քաղաքականությանը և տրամադրելով
                որոշակի անձնական տվյալներ և համաձայնելով դրանց մշակմանը՝ Դուք կկարողանաք օգտվել Հարթակից:
            `
        },
        {
            content: `
                Խնդրում ենք ուշադիր ընթերցել սույն Քաղաքականությունը։ Խնդրում ենք չգրանցվել, մուտք չգործել
                Հարթակ կամ չսկսել օգտվել Հարթակից, եթե չեք կարդացել սույն Քաղաքականությունը կամ համաձայն
                չեք դրա որևէ մասի հետ:
            `
        },
        {
            title: "Թարմացումներ և փոփոխություններ",
            content: `
                Ընկերությունը պահպանում է ցանկացած ժամանակ իր հայեցողությամբ սույն Քաղաքականության ցանկացած
                դրույթ թարմացնելու, փոփոխելու և ձևափոխելու իր իրավունքը: Ձեզ այդ մասին լրացուցիչ կծանուցվի
                փոփոխությունների ուժի մեջ մտնելուց հինգ օր առաջ Հարթակի կամ էլ․ փոստի միջոցով։ Այդ փոփոխություններն
                ուժի մեջ կմտնեն Հարթակում դրանց տեղադրման օրվանից հինգ օր անց։ Եթե Դուք շարունակեք օգտվել
                Հարթակից թարմացումների, փոփոխությունների և ձևափոխումների ուժի մեջ մտնելու ամսաթվից հետո, Դուք
                դրանով բացահայտորեն և անհետկանչելիորեն համաձայնում և ընդունում եք թարմացումները, փոփոխությունները
                 և ձևափոխումները։
            `
        },
        {
            content: `
                Եթե որևէ պահի Դուք չեք համաձայնում այդ պահին գործող Գաղտնիության Քաղաքականությանը
                կամ դրա որևէ մասին, Հարթակից օգտվելու Ձեր լիցենզիան անմիջապես կդադարեցվի, և Դուք
                պարտավոր եք անհապաղ դադարեցնել Հարթակից օգտվելը։
            `
        },
        {
            title: "Տվյալների հավաքումը և օգտագործումը",
            content: `
                Հարթակից Ձեր օգտվելու հետ կապված՝ Դուք Մեզ տրամադրում եք որոշակի անձնական տվյալներ
                Ձեր մասին, ինչպես նկարագրված է ստորև:
            `
        },
        {
            content: `
                Ձեր կողմից Մեզ տրամադրվում է Աշխատողի անունը, ազգանունը, հասցեն, էլեկտրոնային փոստի հասցեն,
                հեռախոսահամարը, ծննդյան ամսաթիվը, սեռը, Ծնողի ամբողջական անուն, սեռ, բնակության վայրի հասցե,
                էլ. փոստի հասցե, հեռախոսահամար, ծննդյան ամսաթիվ, աշխատանքի վայր, Երեխայի ամբողջական անուն,
                հայրանուն, մայրանուն, սեռ, ծննդյան ամսաթիվ, ինչպես նաև սննդային ալերգիաների, առողջական խնդիրների,
                խառնվածքի, զարգացման ընթացքի վերաբերյալ տվյալներ: Նշված տվյալները տրամադրվում են գրանցման,
                նույնականացման, կոնտակտային և Հարթակի արդյունավետ օգտագործման նպատակներով:
            `
        },
        {
            content: `
                Ոչ պարտադիր տվյալներ. Դուք կարող եք Մեզ տրամադրել լրացուցիչ տվյալներ։ Օրինակ՝ Դուք կարող եք
                տրամադրել լրացուցիչ տեղեկություններ Ձեր Երեխայի մասին, ինչպիսիք են՝ առողջական խնդիրների մանրամասներ,
                նախընտրած սնունդ, փոխհարաբերություններ այլ երեխաների հետ, սիրելի խաղալիքներ, խնդրահարույց հատկություններ,
                նախկին նախադպրոցական հաստատություններ, պատվաստումներ: Նշված տվյալները տրամադրվում են Հարթակի արդյունավետ
                օգտագործման նպատակներով:
            `
        },
        {
            content: `
                Դուք պարտավոր չեք Մեզ տրամադրել որևէ տվյալ, սակայն չտրամադրման դեպքում հնարավոր է,
                որ չկարողանանք Ձեզ հասանելի դարձնել Մեր Հարթակը:
            `
        },
        {
            content: `
                Մենք հավաքում ենք ապանձնավորված տվյալներ Հարթակում Ձեր նշած կարգավորումների ու
                Ձեր գործողությունների վերաբերյալ: Մենք տեղեկություններ ենք հավաքում Հարթակ մուտք գործելու
                համար օգտագործվող ցանկացած սարքի մասին: Մենք օգտագործում ենք այս տեղեկությունը՝ վերլուծելու,
                թե ինչպես են օգտատերերն օգտվում Հարթակից՝ բարելավելու Մեր Հարթակի աշխատանքը, գործառույթները և
                մարքեթինգային ու վերլուծության նպատակներով:
            `
        },
        {
            content: `
                Մենք նաև պահպանում ենք Հարթակում հասանելի զրուցարաններից (chat) խոսակցությունների տվյալները
                և կարող ենք մուտք գործել միայն այն դեպքում, երբ անհրաժեշտ լինի անսարքությունների վերացման և
                աջակցության համար: Մենք կարող ենք նաև մուտք գործել այդ տվյալներ հայցեր, պահանջներ ներկայացնելու
                կամ այլ իրավական գործողություններ կատարելու և դրանց պատասխանելու նպատակով:
            `
        },
        {
            title: "Անձնական տվյալների օգտագործումը Մեր կողմից",
            content: `
                Մենք օգտագործում ենք Հարթակի միջոցով հավաքագրված տվյալները Հարթակը հասանելի դարձնելու և բարելավելու,
                Ձեր հարցումներին լուծում տալու, խարդախությունները կանխելու, Ձեզ հետաքրքրող տեղեկություն տրամադրելու,
                օրենսդրության պահանջներին համապատասխանելու նպատակով և Ձեր համաձայնությամբ այլ նպատակներով թույլատրված
                լինելու դեպքերում:
            `
        },
        {
            content: `
                Մենք օգտագործում ենք Մեր կողմից հավաքված տվյալները.
            `
        },
        {
            content: `
                Հարթակը հասանելի դարձնելու և բարելավելու, Ձեր հարցումներին արձագանքելու, Ձեր գրանցումն
                իրականացնելու, Ձեր տրամադրած տեղեկության վավեր լինելը ստուգելու նպատակով, ինչպես նաև
                պահանջներին համապատասխանելու և ներքին բիզնես նպատակների համար:
            `
        },
        {
            content: `
                Հարթակի միջոցով ադմինիստրատիվ հաղորդակցությունների և տեղեկագրերի և Ձեզ հետաքրքրող այլ
                տեղեկությունների վերաբերյալ Ձեզ հետ կապ հաստատելու համար:
            `
        },
        {
            content: `
                Ղեկավարելու և զարգացնելու Մեր գործարար հարաբերությունները Ձեզ հետ և, կիրառելիության դեպքում,
                իրավաբանական անձի հետ, որը Դուք ներկայացնում եք:
            `
        },
        {
            content: `
                Օրենքի պահանջները կիրարկելու և դրանց հետևելու համար, ներառյալ\` հետաքննություն անցկացնելը,
                Ընկերության կամ երրորդ անձանց գույքն ու իրավունքները պաշտպանելը, հասարակության կամ որևէ անձի
                անվտանգությունը պաշտպանելը, այն գործունեության կանխումը կամ դադարեցումը, որը Մենք համարենք,
                որ անօրինական է, խարդախ կամ ոչ էթիկական կամ նման գործողություն համարվելու վտանգ է ստեղծում:
            `
        },
        {
            content: `
                Կատարելու Մեր պայմանագրային պարտականությունները: Մեր կողմից անձնական տվյալների մշակման
                մեծ մասն ուղղված է մեր պայմանագրային պարտականությունների կատարմանը:
            `
        },
        {
            content: `
                Մեր Հարթակը հասանելի դարձնելու, անվտանգության միջադեպերը բացահայտելու, վնասակար, մոլորեցնող,
                խարդախ կամ անօրինական գործողություններից պաշտպանելու և այդ գործունեության համար պատասխանատու
                անձանց պատասխանատվության ենթարկելու, Մեր Հարթակի նկատմամբ հետաքրքրության և ներգրավվածության
                չափը գնահատելու նպատակով, կարճաժամկետ, ժամանակավոր օգտագործման համար, Մեր Հարթակը
                բարելավելու, արդիականացնելու կամ կատարելագործելու, նոր ապրանքներ և ծառայություններ մշակելու,
                որակի ներքին հսկողություն և անվտանգություն ապահովելու, անձանց նույնականացման, վրիպազերծելու
                նպատակով\՝ Մեր Հարթակի հետ կապված սխալները հայտնաբերելու և վերացնելու համար, Մեր համաձայնագրերն
                ու քաղաքականությունները կիրարկելու, Մեր բիզնեսի բարելավման ու վերլուծություններ կատարելու
                նպատակով, հաղորդակցության նպատակով, ներառյալ\` մարքեթինգը և Մեր Հարթակի վերաբերյալ Ձեր
                հարցումներին պատասխանելը, տեղեկատվական անվտանգության կարիքների բավարարման և Մեր օգտատերերի,
                Ընկերության և այլոց պաշտպանման, իրավական խնդիրներ լուծելու, կիրառելի օրենսդրության պահանջներին
                հետևելու և Մեր իրավական պարտավորությունները կատարելու, հայցեր, պահանջներ ներկայացնելու կամ այլ
                իրավական գործողություններ կատարելու, ինչպես նաև դրանց պատասխանելու նպատակով։

            `
        },
        {
            content: `
                Եթե Դուք Աշխատող եք, Մենք մշակում ենք Ձեր անձնական տվյալները ՀՀ Աշխատանքային
                օրենսգրքի 132-րդ հոդվածով սահմանված նպատակներով:
            `
        },
        {
            title: "Ձեր տվյալների բացահայտումը երրորդ անձանց",
            content: `
                Խմբավարը հասանելիություն ունի իր խմբում ներառված Երեխաների տվյալներին: Ծնողը հասանելիություն
                ունի իր Երեխաների և նրանց խմբավարների տվյալներին, ինչպես նաև այլ Ծնողի համաձայնության
                առկայության դեպքում կարող է նաև հասանելիություն ունենալ այդ Ծնողի տվյալներին և նրա Երեխայի
                անվանն ու ազգանվանը: Նշված տվյալների բացահայտումը տեղի է ունենում Հարթակի արդյունավետ
                օգտագործման նպատակով:
            `
        },
        {
            content: `
                Մեր, ինչպես նաև մանկապարտեզի աշխատողներին հասանելի են Ձեր անձնական տվյալները այնքանով,
                որքանով դա անհրաժեշտ է իրենց աշխատանքային պարտականությունները կատարելու համար, ինչպիսին է
                օրինակ\` տեխնիկական աջակցությունը: Բոլոր դեպքերում տվյալների հասանելիությունը տրամադրվում է
                այն աշխատողներին, որոնք դրա կարիքն ունեն վերոնշյալ նպատակով:
            `
        },
        {
            content: `
                Գործընկերներ․ Մենք աշխատում ենք երրորդ անձանց հետ, որոնք տրամադրում են խորհրդատվական,
                աջակցման, տեխնիկական և այլ ծառայություններ՝ Հարթակի շուրջ հաճախորդամետ լուծումներ մատուցելու
                և իրականացնելու նպատակով: Մենք կարող ենք փոխանցել Ձեր տվյալները այս երրորդ անձանց՝ կապված
                նրանց կողմից մատուցվող ծառայությունների հետ: Թեև նման երրորդ անձինք կարող են հասանելիություն
                ունենալ Ձեր անձնական տվյալներին՝ Ընկերության համար ծառայությունների մատուցման կապակցությամբ,
                նրանք չեն կարող օգտագործել այդ տվյալները ծառայությունները մատուցելուց բացի որևէ այլ նպատակով։
            `
        },
        {
            content: `
                Ներպետական կամ միջազգային օրեսնդրությամբ, այլ կարգավորումով կամ դատարանի որոշմամբ Մեզ կարող են
                պարտավորեցնել կամ Մեզնից կարող են հայցել բացահայտել և փոխանցել Ձեր տվյալները, ներառյալ\`
                անձնական տվյալները, պետական մարմիններին և (կամ) դատարաններին:
            `
        },
        {
            title: "Տվյալների պահպանումը",
            content: `
                Անվտանգ և ապահով պահպանումն ապահովելու նպատակով Հարթակի միջոցով հավաքված ամբողջ տեղեկությունը
                կպահպանվի Ամերիկայի Միացյալ Նահանգներում տեղակայված երրորդ անձի ամպային սերվերներում (cloud servers):
            `
        },
        {
            title: "Տվյալների մշակման ժամկետը",
            isHtml: true,
            content: `
                Ձեր տվյալները, ներառյալ\` անձնական տվյալները, կարող են հավաքվել, պահպանվել, վերլուծվել, փոփոխվել,
                բացահայտվել կամ այլ կերպ մշակվել Մեր կողմից՝ առանց ժամանակային սահմանափակման, մշտապես և կանոնավոր
                կերպով, բացառությամբ եթե Դուք պահանջեք ջնջել Ձեր տվյալները, որոնք ամբողջովին կջնջվեն իննսուն օր
                արխիվացումից հետո և որը կարելի է անել՝ գրելով <a href="mailto:support@baleek.am">support@baleek.am</a>
                հասցեին: Ընդ որում, այդ դեպքում Մենք կդադարեցնենք մշակման վերոնշյալ ձևերը, բացառությամբ այն դեպքերի,
                երբ Մենք իրավական պարտավորություն ունենանք պահպանելու արխիվային փաստաթղթերը կամ երբ դրանցից որոշների
                պահպանման անհրաժեշտություն լինի\` ելնելով օրինական նպատակներից կամ այլ պահանջներին հետևելու նպատակով,
                ինչպես նաև բացառությամբ այլ արխիվային փաստաթղթերի, որոնք անհրաժեշտ են հայցեր, պահանջներ ներկայացնելու
                կամ այլ իրավական գործողություններ կատարելու և դրանց պատասխանելու համար: 
            `
        },
        {
            title: "Անվտանգությունը և օրենսդրությանը համապատասխանությունը",
            content: `
                Ձեր անձնական տվյալները և այլ տվյալները կարող են հասանելի լինել և վերահսկվել ըստ անհրաժեշտության՝
                մուտքը դեպի Հարթակ և դրանից օգտվելն ապահովելու համար և կարող են բացահայտվել՝ (i) եթե Մենք
                բարեխղճորեն կարծում ենք, որ Մենք պարտավոր ենք բացահայտել տվյալները ի պատասխան որևէ իրավական
                գործընթացի (օրինակ՝ դատարանի վճռի), (ii) բավարարելու որևէ կիրառելի օրենքների կամ կարգավորումների
                պահանջները, (iii) եթե Մենք կարծում ենք, որ Հարթակն օգտագործվում է անօրինական գործունեություն
                իրականացնելու համար, ներառյալ՝ հայտնելու այդպիսի գործունեության մասին կամ խարդախության
                կանխարգելման նպատակով այլ կողմերի հետ տվյալներ փոխանակելու համար, (iv) եթե Մենք բարեխղճորեն
                կարծում ենք, որ առկա է արտակարգ իրավիճակ, որը սպառնում է Ձեր, մեկ այլ անձի կամ ընդհանրապես
                հանրության առողջությանը և (կամ) անվտանգությանը, և (v) Ընկերության իրավունքները կամ սեփականությունը
                պաշտպանելու, ներառյալ՝ Հարթակից Օգտվելու Պայմանները կիրարկելու համար։
            `
        },
        {
            title: "Տվյալների պաշտպանությունը",
            content: `
                Մենք իրականացնում ենք համապատասխան տեխնիկական և կազմակերպչական միջոցառումներ՝ անվտանգության
                համապատասխան մակարդակ ապահովելու նպատակով: Այնուամենայնիվ, ոչ մի համացանցային փոխանցում կամ
                էլեկտրոնային եղանակով պահպանման մեթոդ լիովին ապահով չէ: Այսպիսով, Մենք ձգտում ենք պաշտպանել
                Ձեր անձնական տվյալները, այնուամենայնիվ Մենք չենք կարող և չենք երաշխավորում Ձեր կողմից Մեզ
                փոխանցվող տեղեկատվության անվտանգությունը: Ցանկացած փոխանցում կատարվում է Ձեր սեփական ռիսկով:
            `
        },
        {
            title: "Ծանոթացում Ձեր տվյալներին, դրանց փոփոխում, ջնջում և մշակման սահմանափակում",
            isHtml: true,
            content: `
                Դուք կարող եք ինքնուրույն փոփոխել Ձեր պրոֆիլի տվյալները:<br>
                Խնդրում ենք նկատի ունենալ, որ որոշ տվյալների ջնջումը կարող է Ձեզ համար հանգեցնել Հարթակի
                որոշակի գործառույթներից օգտվելու անհնարինության:
            `
        },
        {
            isHtml: true,
            content: `
                Հարթակից օգտվելիս ցանկացած ժամանակ Դուք իրավունք ունեք Մեզնից պահանջել և ստանալ հաստատում
                Ձեր անձնական տվյալների մշակման փաստի վերաբերյալ, ինչպես նաև տեղեկություններ և մանրամասներ
                այդ մշակման վերաբերյալ և խնդրել, որ հնարավորության դեպքում հասանելիություն ունենաք Ձեր տվյալներին։
                Հասանելիություն ունենալու նման իրավունքը կարող է իրացվել անձնական տվյալների պաշտպանության մասին
                կիրառելի օրենքի համաձայն։ Խնդրում ենք համապատասխան հարցումները ներկայացնել
                <a href="mailto:support@baleek.am">support@baleek.am</a> հասցեին:
            `
        },
        {
            isHtml: true,
            content: `
                Դուք իրավունք ունեք պահանջելու վերանայել, փոխել կամ ուղղել Ձեր մասին Ընկերության ունեցած տեղեկությունը,
                եթե կարծում եք, որ տեղեկությունը, ներառյալ՝ անձնական տվյալները, սխալ են, թերի, ապակողմնորոշիչ,
                կարող են վնաս պատճառել կամ որևէ կերպ չեն համապատասխանում իրականությանը կամ այլ ողջամիտ պատճառներով։
                Խնդրում ենք համապատասխան հարցումները ներկայացնել <a href="mailto:support@baleek.am">support@baleek.am</a> հասցեին։
            `
        },
        {
            isHtml: true,
            content: `
                Մոռացված լինելու իրավունք. Օգտատերերն իրավունք ունեն Մեզնից պահանջելու ջնջել իրենց անձնական
                տվյալները կամ օգտահաշիվն ամբողջությամբ, ինչպես նաև իրավունք ունեն պահանջելու սահմանափակել
                իրենց անձնական տվյալների մշակումը՝ հաշվի առնելով սույն Քաղաքականության «Տվյալների մշակման
                ժամկետը» բաժինը։ Անձնական տվյալների ջնջումը և մշակման սահմանափակումները պետք է իրականացվեն
                անձնական տվյալների պաշտպանության մասին կիրառելի օրենքին համապատասխան: Խնդրում ենք համապատասխան
                հարցումները ներկայացնել <a href="mailto:support@baleek.am">support@baleek.am</a> հասցեին:
            `
        },
        {
            content: `
                Մենք կփորձենք ողջամիտ ժամկետում բավարարել Ձեր ցանկացած հարցում\` միևնույն ժամանակ հաշվի
                առնելով սույն Քաղաքականության «Տվյալների մշակման ժամկետը» բաժնում նշվածը:
            `
        },
        {
            title: "Բողոքներ և կիրառելի օրենսդրություն",
            content: `
                Սույն Քաղաքականությունը և դրանից բխող կամ դրա հետ կապված ցանկացած հարաբերություն կարգավորվում է
                Հայաստանի Հանրապետության օրենսդրությամբ:
            `
        },
        {
            content: `
                Եթե ունենաք որևէ խնդիր Մեր կողմից Ձեր տվյալների, ներառյալ անձնական տվյալների, մշակման հետ
                կապված, պետք է գրավոր հասցեագրեք Մեզ, և տվյալ խնդիրը պետք է լուծվի բանակցությունների միջոցով:
                Վեճերը բանակցությունների միջոցով 30 օրվա ընթացքում լուծելու ձախողման դեպքում Դուք իրավունք
                ունեք նման հարցերով դիմել վերահսկող մարմնին։
            `
        },
        {
            title: "Կոնտակտային տեղեկություն",
            isHtml: true,
            content: `
                Սույն Քաղաքականության կամ Ձեր տվյալների մշակման վերաբերյալ հարցերի առկայության կամ Հարթակից
                օգտվելու վերաբերյալ աջակցության կարիք ունենալու պարագայում, խնդրում ենք կապ հաստատել
                Մեզ հետ էլ․ փոստի միջոցով հետևյալ հասցեով՝ <a href="mailto:support@baleek.am">support@baleek.am</a>
            `
        },
    ];

    const sectionsEn: IPrivacySection[] = [
        {
            title: "General",
            content: `
                The present privacy policy constitutes an integral part of the Terms of Use of the Platform – a legally
                binding agreement between You and PRAGMATIX limited liability company (legal address: apt. 14,
                31 Demirchyan str., Yerevan, Republic of Armenia).
            `
        },
        {
            content: `
                Capitalized terms used herein and not otherwise defined herein shall have the meanings assigned to them
                in the Terms of Use of the Platform.
            `
        },
        {
            content: `
                The present privacy policy (“Policy”) is aimed at informing You of Our policies and procedures
                regarding the collection, use and disclosure of data We receive from You.
            `
        },
        {
            content: `
                By using the Platform, You explicitly and irrevocably consent and agree to the processing of the data
                We receive from You, including its collection, use and disclosure in relation to the use of the Platform
                in accordance with this Policy. You give the said consent both in terms of Your personal data and if
                applicable, the Child’s personal data as the legal representative of the Child.
            `
        },
        {
            content: `
                You are not obliged to agree to this Policy and the provision and processing of personal data in accordance
                with it. However, only by agreeing to this Policy and providing certain personal data and Your consent to
                its processing will You be able to use the Platform.
            `
        },
        {
            content: `
                Please read this Policy carefully. Please do not register in the Platform, access it, or start using it in
                any way if You have not read the Policy, or if You do not agree to any part of this Policy.
            `
        },
        {
            title: "Updates and Modifications",
            content: `
                The Company reserves the right to update, change or modify any term of this Policy at any time, in its sole
                discretion. You will be notified about the change on the Platform or via email five days before the changes
                become effective. These changes become effective five days after the date of their placement on the Platform.
                If You continue to use the Platform following the effective date of updates, changes or modifications,
                You thereby explicitly and irrevocably agree to and accept the updates, changes or modifications.
            `
        },
        {
            content: `
                If You at any point do not agree to any portion of then-current Policy, Your license to use the Platform
                shall immediately terminate and You must immediately stop using the Platform.
            `
        },
        {
            title: "Collection and Use of Data",
            content: `
                In connection with Your use of the Platform, You provide Us with certain personal data about You, as described below.
            `
        },
        {
            content: `
                You provide Us with the Employee’s name, surname, address, email address, phone number, date of birth,
                gender, Parent’s full name, gender, residential address, email address, phone number, date of birth,
                place of work, Child’s full name, father’s name, mother’s name, gender, date of birth, as well as data
                on food allergies, health problems, temperament, development process. The specified data is provided for
                purposes of registration, identification, contacting and efficient use of the Platform.
            `
        },
        {
            content: `
                Non-mandatory information: You may provide Us with further information. For example, You may provide
                additional information about Your Child, such as details of health problems, preferred food, interactions
                with other children, favorite toys, problematic behaviors, previous preschool establishments, vaccinations.
                The specified data is provided for the purpose of efficient use of the Platform.
            `
        },
        {
            content: `
                You do not have to provide Us with any data, but if You do not, We may not be able to provide You with Our Platform.
            `
        },
        {
            content: `
                We collect depersonalized data about the settings and Your actions on the Platform. We collect information
                about any device used to access the Platform. We use this information to analyze how users use the Platform
                to improve Our Platform performance, features, and for marketing and analytics purposes.
            `
        },
        {
            content: `
                We also store conversations’ data from the chats available on the Platform and may access it only when
                needed for troubleshooting and support. We may also access it in the event of filing or defending
                claims or other legal actions.
            `
        },
        {
            title: "Use of the Personal Data by Us",
            content: `
                We use data collected through the Platform to provide and improve the Platform, process Your requests,
                prevent fraud, provide You with information that may interest You, comply with the law, and as otherwise
                permitted with Your consent.
            `
        },
        {
            content: `
                We use the data We collect:
            `
        },
        {
            content: `
                To provide and improve the Platform, address Your inquiries, process Your registration, verify the
                information You provide is valid, and for compliance and internal business purposes.
            `
        },
        {
            content: `
                To contact You regarding administrative communications and newsletters and other information that may
                be of interest to You through the Platform.
            `
        },
        {
            content: `
                To administer and develop Our business relationship with You and, if applicable, the legal entity You represent.
            `
        },
        {
            content: `
                To enforce and comply with the law, including to conduct an investigation, to protect the property
                and rights of the Company or a third party, to protect the safety of the public or any person, or
                to prevent or stop activity We may consider to be, or to pose a risk of being, illegal, fraudulent
                or unethical activity.
            `
        },
        {
            content: `
                To honor Our contractual commitments. Much of Our processing of personal data is to meet Our contractual obligations.
            `
        },
        {
            content: `
                To provide Our Platform; detect security incidents, protect against malicious, deceptive, fraudulent or illegal activity,
                and prosecute those responsible for that activity; measure interest and engagement in Our Platform; short-term, transient
                use; improve, upgrade or enhance Our Platform; develop new products and services; ensure internal quality control and safety;
                authenticate and verify individual identities; debug to identify and repair errors with Our Platform; enforce Our agreements
                and policies; analyze and improve Our business; communications, including marketing and responding to Your inquiries about
                Our Platform; address information security needs and protect Our users, the Company, and others; manage legal issues; comply
                with the applicable law and Our legal obligations; file or defend any pending or possible claims or legal actions.
            `
        },
        {
            content: `
                If you are an Employee, We process Your personal data for the purposes defined by Article 132 of the Labor Code of the Republic of Armenia.
            `
        },
        {
            title: "Disclosure of Your Data to Third Parties",
            content: `
                The group conductor has access to the data of the Children included in his group. A Parent has access to the data of his
                Children and their group conductors, and with the consent of another Parent, may also have access to that Parent’s
                data and the latter’s Child’s name and surname. Disclosure of the specified data takes place for the purpose of
                efficient use of the Platform.
            `
        },
        {
            content: `
                Our employees, as well as employees of the kindergarten, have access to Your personal data to the extent necessary to
                perform their work duties, such as technical support. In all cases, access to data is provided to employees who need
                it for the foregoing purpose.
            `
        },
        {
            content: `
                Partners: We work with third parties who provide consulting, support, technical and other services to deliver and
                implement customer solutions around the Platform. We may share Your data with these third parties in connection
                with their services. Although such third parties may have access to Your personal data in connection with the provision
                of services for the Company, they may not use such information for any purpose other than providing the services.
            `
        },
        {
            content: `
                We may be obliged or otherwise requested under the law or other regulation or court decision, both national
                or international, to disclose and share Your information, including personal data, with the state
                authorities and/or courts.
            `
        },
        {
            title: "Information Storage",
            content: `
                To ensure safe and secure storage, all the information collected via the Platform will be stored on third
                party cloud servers located in the United States of America.
            `
        },
        {
            title: "Period of Data Processing",
            isHtml: true,
            content: `
                Your information, including personal data can be collected, stored, analyzed, changed, disclosed, or otherwise
                processed by Us without any time limitations, permanently and on regular basis, unless You request to delete Your
                data, which will be completely deleted after ninety days of archiving and which can be done by writing to
                <a href="mailto:support@baleek.am">support@baleek.am</a>. At that, We will stop the above-mentioned forms of
                processing, except where We have legal obligation to retain the records or where certain records may need to be
                retained for legal or compliance purposes as well as other records needed to file or defend any pending or
                possible claims or legal actions.
            `
        },
        {
            title: "Safety, Security and Compliance with Law",
            content: `
                Your personal data and other information may be accessed and monitored as necessary to provide access to or use of
                the Platform and may be disclosed: (i) when We have a good faith belief that We are required to disclose the information
                in response to a legal process (for example, a court order); (ii) to satisfy any applicable laws or regulations;
                (iii) where We believe that the Platform is being used in the commission of an illegal activity, including to report
                such activity or to exchange information with other parties for the purposes of fraud prevention; (iv) when We have a
                good faith belief that there is an emergency that poses a threat to the health and/or safety of You, another person or
                the public generally; and (v) in order to protect the rights or property of the Company, including to enforce Our Terms of Use.
            `
        },
        {
            title: "Data Security",
            content: `
                We implement appropriate technical and organizational measures to ensure an appropriate level of security. However, no
                internet transmission or method of electronic storage is completely secure. Thus, while We strive to protect Your personal
                data, We cannot ensure and do not warrant the security of any information You transmit to Us. Any transmission is at Your own risk.
            `
        },
        {
            title: "Access, Change, Erasure, and Restriction of Your Data",
            isHtml: true,
            content: `
                You can modify Your profile information Yourself.<br>
                Please note that deleting certain data may prevent You from using certain features of the Platform.            
            `
        },
        {
            isHtml: true,
            content: `
                At any time of Your use of the Platform You have the right to request and obtain from Us confirmation as
                to whether We are processing any personal data, as well as information and details on such processing and
                request to have access, if possible, to Your information. Such right of access can be exercised in accordance
                with applicable law on data protection. Please submit corresponding requests to
                <a href="mailto:support@baleek.am">support@baleek.am</a>.
            `
        },
        {
            isHtml: true,
            content: `
                You have the right to request review, change or rectification of the information the Company has about You,
                if You deem that the information, including personal data is incorrect, incomplete, misleading, injurious or
                does not correspond to reality in any way or for any reasonable reasons. Please, submit corresponding
                requests to <a href="mailto:support@baleek.am">support@baleek.am</a>.
            `
        },
        {
            isHtml: true,
            content: `
                Right to be forgotten. Users have the right to request from Us the erasure of their personal data or their
                account entirely as well as the right to restrict the processing of their personal data taking into account
                the “Period of Data Processing” section of this Policy. The erasure and restrictions of personal data shall be
                performed in accordance with the applicable law on data protection. Please submit corresponding requests
                to <a href="mailto:support@baleek.am">support@baleek.am</a>.
            `
        },
        {
            content: `
                We will attempt to accommodate any of Your requests within reasonable period without prejudice to the
                “Period of Data Processing” section of this Policy.
            `
        },
        {
            title: "Complaints and Applicable Law",
            content: `
                This Policy and any relations arisen from or in connection with it shall be governed by the laws of the
                Republic of Armenia.
            `
        },
        {
            content: `
                Any issues that You might have regarding the processing of Your data, including personal data, by Us shall be
                addressed to Us in a written form and resolved through negotiations. In case of failure of resolving the disputes
                through negotiations within 30 days, You have the right to apply to the supervisory authority on such matters.
            `
        },
        {
            title: "Contact Information",
            isHtml: true,
            content: `
                If You have any questions about this Policy or processing of Your data, or else need any support as to the use of
                the Platform, please feel free to contact Us by email at <a href="mailto:support@baleek.am">support@baleek.am</a>.
            `
        },
    ];

    return (
        <section className={`${styles.privacyPolicy}`}>
            <div className="container">
                <Link className="lang-switcher" href={`/terms/${lang === 'en' ? '' : '?lang=en'}`}>
                    {lang === 'en' ? "Armenian" : "English"}
                </Link>
                <h2 className={'text-center mb-5'}>{getSimpleTranslation('privacy-policy', {}, lang)}</h2>
                <ul className={'p-0'}>
                    {(lang === 'en' ? sectionsEn : sections).map((s, index) => <Fragment key={index}>{getSection(s)}</Fragment>)}
                </ul>
                <p className={'fw-bold'}>{getSimpleTranslation("updatedOn", {date: "27/03/2024"}, lang)}</p>
            </div>
        </section>
    );

    function getSection(section: IPrivacySection) {
        return (
            <li className={'mb-3'}>
                {section.title && <h5 className={'mb-1'}>{section.title}</h5>}
                <p {...(section.isHtml ? {dangerouslySetInnerHTML: {__html: section.content}} : {})}>{section.isHtml ? null : section.content}</p>
            </li>
        )
    }
}
